/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { compareNaturalDependencies } from './dependenciesCompareNatural.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createSetSize } from '../../factoriesAny.js';
export var setSizeDependencies = {
  compareNaturalDependencies: compareNaturalDependencies,
  typedDependencies: typedDependencies,
  createSetSize: createSetSize
};